<template>
  <embedded-crud-table
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :definition="definition"
    :generate-summary="generateSummary"
    :caption="caption"
    :parent-id-filter-field="parentIdFilterField"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :permission-code="permissionCode"
    :create-item-from-form-data="createItemFromFormData"
    :create-form-data-from-item="createFormDataFromItem"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import formMixin from './form-mixin';

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [formMixin],
  props: {
    caption: String,
    parentIdFilterField: {
      type: String,
      required: true
    },
    permissionCode: String,
    disabled: {
      default: false,
      type: Boolean
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      columns: [
        {
          field: 'priceListItemDescription',
          label: 'domain.deliveryPrice',
          minWidth: '100px',
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'countryName',
          label: 'common.country',
          minWidth: '100px',
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'deliveryPriceType',
          label: 'common.type',
          minWidth: '100px',
          formatter: this.formatDeliveryPriceType,
          filter: { type: 'none' },
          sortable: false
        }
      ]
    };
  },
  computed: {
    priceListItems() {
      return this.$store.getters['priceListItem/loadedItems'];
    },
    countries() {
      return this.$store.getters['country/loadedItems'];
    },
    deliveryPriceTypes() {
      return this.$store.getters['option/loadedOptions']('deliveryPrice');
    }
  },
  watch: {
    priceListItems(priceListItems) {
      this.getColumn('priceListItemDescription').filter.options = priceListItems;
    },
    countries(countries) {
      this.getColumn('countryName').filter.options = countries;
    },
    deliveryPriceTypes(deliveryPriceTypes) {
      this.getColumn('deliveryPriceType').filter.options = deliveryPriceTypes;
    }
  },
  methods: {
    getColumn(fieldName) {
      return this.columns.find(c => c.field === fieldName);
    },
    generateSummary(row) {
      return `${row.description}`;
    },
    formatDeliveryPriceType(row, column, cellValue) {
      const option = cellValue !== null && this.deliveryPriceTypes.find(item => item.code === cellValue);
      return option && option.description;
    }
  }
};
</script>

<style lang="scss" scoped></style>
